import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const issueNavigatorProjectListServicedeskRoute: InvariantJiraRoute = {
	name: 'jsm-list-nin',
	path: '/jira/servicedesk/projects/:projectKey/list/:navigationItemId?',
};
